<template>
    <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 23.06 21.44"
    >
        <g class="cls-2">
            <g id="Group_3982" data-name="Group 3982">
                <path
                    id="Path_745"
                    data-name="Path 745"
                    class="cls-3"
                    d="M22.39,13.94a8.88,8.88,0,0,0,.66-3.64,9.87,9.87,0,0,0-1.43-5.24,10.06,10.06,0,0,0-4-3.7A12.63,12.63,0,0,0,11.7,0,12.88,12.88,0,0,0,5.55,1.43a10.33,10.33,0,0,0-4.1,3.9A10.94,10.94,0,0,0,0,10.91a11.05,11.05,0,0,0,1.44,5.62,8.68,8.68,0,0,0,4,3.9c5.18,2.2,8.33.3,9.76-1.05a12,12,0,0,1-3.62.55,9.73,9.73,0,0,1-4.75-1.15,8,8,0,0,1-3.22-3.22A9.37,9.37,0,0,1,2.5,10.92,9.08,9.08,0,0,1,3.65,6.33,8.3,8.3,0,0,1,6.92,3.11,9.82,9.82,0,0,1,11.7,2,10.39,10.39,0,0,1,16.48,3a7.88,7.88,0,0,1,3.25,3,8.26,8.26,0,0,1,1.15,4.36c0,2.57-.58,4-1.8,4.5a2,2,0,0,1-1.62-.1c-.78-.6-.39-1.66-.18-2.23a1.43,1.43,0,0,0,.09-.27,5.23,5.23,0,0,0,.35-1.88A3,3,0,0,0,15,7.17a4.37,4.37,0,0,0-3,1.76l-.43.6-.25-.7a3,3,0,0,0-5.68,1.56c0,3.26,3.89,5.69,5.56,6.58a1.23,1.23,0,0,0,1.09,0,14,14,0,0,0,3-1.91l.44-.37.18.55a2.89,2.89,0,0,0,.7,1.06,2.26,2.26,0,0,0,1.71.62,3.71,3.71,0,0,0,2.32-.76,5.19,5.19,0,0,0,1.79-2.25"
                />
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'ShareWithPatientIcon'
}
</script>

<style lang="scss" scoped>
svg {
    width: 23.06px;
    height: 21.44px;
    margin: auto;
    path {
        fill: $white;
    }
}
svg:hover {
    path {
        fill: $pink;
    }
}
</style>